<template>
  <main>
    <Figure
      v-if="post.gds_featured_image"
      :data="post.gds_featured_image"
    />
    <Title :data="{ value: post.title.rendered }" />
    <RichText :data="{ value: post.content.rendered }" />
  </main>
</template>

<script>
import Figure from '@/components/media/figure';
import Title from '@/components/typo/title';
import RichText from '@/components/typo/richtext';

import data from '@/mixins/data';

export default {
  name: 'Single',
  components: {
    Figure,
    Title,
    RichText,
  },
  mixins: [data],
};
</script>
